/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
export const MINI_PLAYGROUND_CALLBACK_EVENT = 'mini-playground-callback';
